import AmiBrokersBanner from './AmiBrokersBanner';
import AmiBrokersSection from './AmiBrokersSection';

function AmiBrokers() {
  return (
    <div>
      <AmiBrokersBanner />
      <AmiBrokersSection />
    </div>
  );
}

export default AmiBrokers;